import { z } from 'zod';

const FUEL_TYPES = [
  'diesel',
  'diesel_s10',
  'gasoline',
  'ethanol',
  'flex',
  'electric',
  'cng',
] as const;

const CATEGORIES = ['car', 'van', 'truck', 'motorcycle', 'machine', 'other'] as const;

const plateRegex = /^[A-Z]{3}[0-9][0-9A-Z][0-9]{2}$/;

export const vehicleFormSchema = z.object({
  plate: z
    .string()
    .trim()
    .min(1, 'Informe a placa')
    .transform((v) => v.replace(/[\s-]/g, '').toUpperCase())
    .refine((v) => plateRegex.test(v), 'Placa inválida. Ex: ABC1D23 ou ABC1234.'),
  brand: z.string().trim().max(64).optional().or(z.literal('')),
  model: z.string().trim().max(64).optional().or(z.literal('')),
  year: z
    .union([z.string(), z.number()])
    .transform((v) => (v === '' || v == null ? undefined : Number(v)))
    .pipe(
      z
        .number()
        .int()
        .min(1900)
        .max(new Date().getFullYear() + 1)
        .optional(),
    )
    .optional(),
  color: z.string().trim().max(32).optional().or(z.literal('')),
  renavam: z.string().trim().max(20).optional().or(z.literal('')),
  chassi: z.string().trim().max(20).optional().or(z.literal('')),
  fuelType: z.enum(FUEL_TYPES),
  category: z.enum(CATEGORIES),
  /** Capacidade do tanque em LITROS (convertido para mL antes do envio) */
  tankCapacityL: z
    .union([z.string(), z.number()])
    .transform((v) => (v === '' || v == null ? undefined : Number(v)))
    .pipe(z.number().min(0).max(2000).optional())
    .optional(),
  /** Odômetro em KM (convertido para metros antes do envio) */
  odometerKm: z
    .union([z.string(), z.number()])
    .transform((v) => (v === '' || v == null ? undefined : Number(v)))
    .pipe(z.number().min(0).optional())
    .optional(),
  crlvNumber: z.string().trim().max(32).optional().or(z.literal('')),
  crlvExpiresAt: z.string().trim().optional().or(z.literal('')),
  anttRntrc: z.string().trim().max(32).optional().or(z.literal('')),
  notes: z.string().trim().optional().or(z.literal('')),
  /**
   * Tipo de medição usado pelo veículo.
   * - 'odometer': km (carros, caminhões)
   * - 'hourmeter': horas (máquinas agrícolas, escavadeiras)
   * - 'both': ambos
   */
  measurementType: z.enum(['odometer', 'hourmeter', 'both']).default('odometer'),
});

export type VehicleFormInput = z.infer<typeof vehicleFormSchema>;
